import { render, staticRenderFns } from "./list-select.vue?vue&type=template&id=5474babe&scoped=true"
import script from "./list-select.vue?vue&type=script&lang=js"
export * from "./list-select.vue?vue&type=script&lang=js"
import style0 from "./list-select.vue?vue&type=style&index=0&id=5474babe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474babe",
  null
  
)

export default component.exports